import {Fragment, useContext} from "react";
import {AppContext} from "../contexts/AppContext";
import {useLocation} from "react-router-dom";
import {DeliveryStatusType} from "../contexts/contextTypes";
import CustomerInputs from "./CustomerInputs";
import Feedback from "../components/Feedback";
import Dashboard from "./Dashboard";
import NotFound from "./NotFound";

const Home = () => {
  const {trackingDetails, isCustomerInputsOpen} = useContext(AppContext);
  const {pathname} = useLocation();
  const splitPath = pathname.split("/")[1];

  /*
   * if trackingDetails.task.status = COMPLETED
   *      if trackingDetails.feedbackId ---> Success Message
   *      else ---> Feedback
   * else if trackingDetails.task.consumerUpdatedInfoAt = null ---> CustomerInputs
   * else if trackingDetails.task.status = IN_PROGRESS --> Map
   * else if trackingDetails.package.status = FAILED
   *      if trackingDetails?.package?.status = CANCELLED ---> Cancelled page
   *      else if trackingDetails?.package?.status = BROKEN ---> Broken page
   *      else if trackingDetails?.package?.status = RETURNED_TO_MERCHANT ---> Return to merchant page
   *      else ---> Failed page
   * else ---> Dashboard
   * */

  return (
      <Fragment>
        {splitPath === "cs" ? (
            <Dashboard isCustomerService={true}/>
        ) : splitPath === "p" ? (
            <Fragment>
              {trackingDetails?.task?.status === DeliveryStatusType.COMPLETED ? (
                  <Feedback/>
              ) : isCustomerInputsOpen ? (
                  <CustomerInputs/>
              ) : (
                  <Dashboard isCustomerService={false}/>
              )}
            </Fragment>
        ) : (
            <NotFound/>
        )}
      </Fragment>
  );
};

export default Home;
